
/**
 * confirm_phone_shown
 * Открыт экран авторизации по звонку
 */
export interface ConfirmPhoneShown {}

export function mapConfirmPhoneShownEvent(event: ConfirmPhoneShown): object {
  const props: Record<string, unknown> = {
  };

  return {
    event: 'analytics_event',
    event_name: 'confirm_phone_shown',
    event_properties: {},
  };
}
